import { Context } from "@/App";
import useDialog from "@/base-components/hooks/useDialog";
import Icon, { Icons } from "@/base-components/Icons";
import Table, { TableProps } from "@/base-components/Table";
import Text from "@/base-components/Text";
import { RoutePath, SPACING } from "@/generic/config";
import { Box, Flex, IconButton } from "@chakra-ui/react";
import React from "react";
import { WorksiteSearchWithResults } from "../worksite/WorksiteSearchPage";
import { ValidationMessage } from "@/base-components/hooks/useModel";
import Worksite, { WorksiteHit } from "@/model/worksite";
import Tooltip from "@/base-components/Tooltip";

/**
 * A component that displays a worksite in a table. Primarily used to show a connected worksite in a table.
 */
const ConnectedWorksiteBox = ({ worksite, showTitle = true, onConnect }: { worksite?: WorksiteHit | Worksite, validationMessage?: ValidationMessage<any>, showTitle?: boolean, onConnect?: (worksite: WorksiteHit) => void }) => {
    const { translations } = React.useContext(Context);
    const hasWorksite = (worksite && worksite.id > 0) ?? false;
    const dialog = useDialog();

    const onSearchWorksite = () => {
        dialog.openDialog({
            title: translations.model.worksite.search.title,
            body: <WorksiteSearchWithResults onRowClick={(row: WorksiteHit) => {
                onConnect?.(row);
                dialog.closeDialog();
            }} />,
            buttons: [],
            size: "xl",
            forcedHeight: "50vh",
        });
    }

    const tableProps: TableProps<Worksite | WorksiteHit> = {
        columns: [
            { title: translations.model.worksite.id, scale: 1, getter: (r) => r.id },
            { title: translations.model.worksite.externalId, scale: 1, getter: (r) => r.externalId },
            { title: translations.model.worksite.name, scale: 1, getter: (r) => r.name },
            // { title: translations.model.worksite.address, scale: 1, getter: (r) => `${r.address?.street || ''} ${r.address?.city || ''}`.trim() },
        ],
        rows: worksite?.id ? [worksite] : [],
        href: (row) => `${RoutePath.Worksites}/${row.id}`,
    };

    return (
        <Box>
            {showTitle && <Text variant="title">{translations.model.worksite.worksite}</Text>}
            {hasWorksite && (
                <Box>
                    <Table tableProps={tableProps} />
                </Box>
            )}
            {!hasWorksite && (
                <Flex alignItems="center">
                    <Text>{translations.model.order.noWorksiteConnected}</Text>
                    <Tooltip tooltip={translations.model.order.noWorksiteConnected} >
                        <Icon size="xs" icon={Icons.Warning} color={"red"} ml={SPACING} />
                    </Tooltip>
                </Flex>
            )}
            <Flex justifyContent="flex-end">
                {onConnect && (
                    <IconButton onClick={onSearchWorksite}>
                        <Icon icon={Icons.Search} />
                    </IconButton>
                )}
            </Flex>
        </Box>
    );
};

export default ConnectedWorksiteBox;
